import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const TOKEN_KEY = 'bigtime_customer_token';
const CUSTOMER_KEY = 'bigtime_customer_data';

export function getCustomerToken() {
  try { return localStorage.getItem(TOKEN_KEY) || ''; } catch { return ''; }
}
export function getStoredCustomer() {
  try { const raw = localStorage.getItem(CUSTOMER_KEY); return raw ? JSON.parse(raw) : null; } catch { return null; }
}
function setSession(token, customer) {
  localStorage.setItem(TOKEN_KEY, token);
  localStorage.setItem(CUSTOMER_KEY, JSON.stringify(customer || {}));
}
export function clearCustomerSession() {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(CUSTOMER_KEY);
}

export async function customerRegister({ email, name, cedula }) {
  const { data } = await axios.post(`${API}/customer/register`, { email, name, cedula });
  setSession(data.access_token, data.customer);
  return data.customer;
}
export async function customerLogin({ email, cedula }) {
  const { data } = await axios.post(`${API}/customer/login`, { email, cedula });
  setSession(data.access_token, data.customer);
  return data.customer;
}
export async function customerMe() {
  const token = getCustomerToken();
  if (!token) throw new Error('no-session');
  const { data } = await axios.get(`${API}/customer/me`, { headers: { Authorization: `Bearer ${token}` } });
  return data;
}
